
  $(document).on('change', 'input[name="shipment_method"], input[name="payment_method"]', function()
  {
    var section = $(this).parents('.gui-section');
    var parent  = $(this).parents('[data-method]');

    $(section).find('[data-subform]').hide();

    parent.find('[data-subform]').show();
  });
